import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import 'react-slidedown/lib/slidedown.css'
import { handleEnterKey } from './utils'
import Pagination from '../common/Pagination'
import { useParams } from 'react-router-dom'
import { getRequest } from '../../services/base'

const HarnessesSearchTable = (props) => {
  const { vehicle } = useParams()

  const [state, setState] = useState({
    searchQuery: props.searchQuery ? props.searchQuery : '',
  })

  const [harnesses, setHarnesses] = useState([])

  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    current_page: 1,
  })

  const { onSelectHarness, selectedHarnessesIds } = props

  useEffect(() => {
    fetchHarnesses()
  }, [])

  const fetchHarnesses = async (url) => {
    let response = await getRequest(
      url
        ? url
        : `/api/harnesses/?search=${
            state?.searchQuery ? state?.searchQuery : ''
          }&vehicle=${vehicle}`
    )
    if (response?.results?.length > 0) {
      setHarnesses(response.results)
      setPagination(response.pagination)
    }
  }

  const setSearchQuery = (event) => {
    setState({ searchQuery: event.target.value })
  }

  const onEnter = (evt) => {
    handleEnterKey(evt, () =>
      fetchHarnesses(pagination && pagination.current_page)
    )
  }

  return (
    <div className="flex items-stretch flex-grow">
      <div className="flex-1 w-1/2 flex flex-col bg-tracer-darker-blue px-4 pb-4 flex-grow">
        <div className="text-white mb-6">
          <div className="flex">Select Harness</div>
        </div>
        <div className="w-full">
          <form
            className="flex flex-col w-full space-y-2 pb-5"
            action={''}
            acceptCharset="UTF-8"
            method="get"
          >
            <div className="flex space-x-5">
              <div className="w-2/3">
                <input
                  autoComplete="off"
                  className="w-full bg-white h-10 px-5 pr-5 rounded focus:outline-none"
                  placeholder="Enter Harness Name"
                  type="search"
                  name="q[full_cont]"
                  value={state.searchQuery || ''}
                  onChange={(e) => setSearchQuery(e)}
                  onKeyDown={onEnter}
                />
              </div>
              <div className="w-1/3">
                <span
                  className="btn"
                  onClick={(e) =>
                    fetchHarnesses(pagination && pagination.current_page)
                  }
                >
                  Search
                </span>
              </div>
            </div>
          </form>
        </div>
        <div className="flex-auto overflow-auto h-56">
          {harnesses
            .filter(({ id }) => !selectedHarnessesIds.includes(id))
            .map((h, i) => (
              <div
                key={i}
                className="flex flex-row items-center bg-white w-full cursor-pointer"
                onClick={() => onSelectHarness(h)}
              >
                <div className="flex flex-row items-center bg-white w-full px-4 py-3 border-b border-tracer-dark-blue">
                  <div className="font-bold">{h.harness_id}</div>
                </div>
              </div>
            ))}
        </div>
        <Pagination
          onClickNext={(e) => {
            fetchHarnesses(e)
          }}
          onClickPrev={(e) => {
            fetchHarnesses(e)
          }}
          context={pagination}
        />
      </div>
    </div>
  )
}

HarnessesSearchTable.propTypes = {
  onSelectHarness: PropTypes.func.isRequired,
  selectedHarnessesIds: PropTypes.array,
}

export default HarnessesSearchTable
